import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  display: flex;
  margin-bottom: ${toVw(72)};
  flex-wrap: nowrap;

  &:last-child {
    margin-bottom: 0;
  }

  > a {
    display: block;
    width: 100%;
  }

  ${mq.tablet(css`
    flex-wrap: wrap;
    margin-bottom: ${toVwTablet(51)};
  `)};

  ${mq.mobile(css`
    display: block;
    margin-bottom: ${toVwMobile(48)};
  `)};
`;

const Row = ({ children }) => (
  <Styled data-test="content-row" data-row>
    {children}
  </Styled>
);

Row.propTypes = {
  index: PropTypes.number.isRequired,
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/ContentRows/components/Row.js